// extracted by mini-css-extract-plugin
module.exports = {"textList":"FooterNavigationDietItem_textList__1xdR8"};